<div class="flex flex-row justify-between">
  <div class="flex flex-row items-center">
    <p-breadcrumb
      [model]="items"
      [home]="home"
    />
    <span>
      <p-tag
        class="ms-2"
        severity="secondary"
        [value]="'v' + this.fallaufgabenService.selectedFallaufgabe.version"
        [rounded]="true"
      />
      <p-tag
        class="ms-2"
        [value]="this.fallaufgabenService.selectedFallaufgabe.category"
        [rounded]="true"
      />
      <p-tag
        class="ms-2 me-2"
        severity="contrast"
        [value]="this.fallaufgabenService.selectedFallaufgabe.type.toUpperCase()"
        [rounded]="true"
      />
      @switch (this.fallaufgabenService.selectedFallaufgabe.state) {
      @case ('draft') {
      <p-tag
        severity="info"
        value="Draft"
        [rounded]="true"
      />
      }
      @case ('live') {
      <p-tag
        severity="success"
        value="Live"
        [rounded]="true"
      />
      }
      @case ('archived') {
      <p-tag
        severity="warn"
        value="Archiviert"
        [rounded]="true"
      />
      }
      }
    </span>
  </div>
  <div>
    <p-button
      severity="secondary"
      label="Prüfung testen"
      (onClick)="this.startNewUserSession()"
    ></p-button>
  </div>
</div>

<p-tabs value="0">
  <p-tablist>
    <p-tab value="0">Aufgaben und Teilaufgaben</p-tab>
    <p-tab value="1">Einstellungen</p-tab>
    <p-tab value="2">Bewertungsmatrix</p-tab>
    <p-tab value="3">Gestartete Prüfungen</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <p-treetable
        [value]="this.tasks"
        [scrollable]="true"
        [tableStyle]="{'min-width':'50rem'}"
      >
        <ng-template #header>
          <tr>
            <th style="width:3rem"></th>
            <th style="width:3rem">Nr.</th>
            <th class="w-[60%]">Name</th>
            <th>Punkte</th>
            <th>Typ</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template
          #body
          let-rowNode
          let-rowData="rowData"
        >
          @if (rowData.type !== 'addButton') {
          <tr [ttRow]="rowNode">
            <td
              style="width:3rem"
              [ngClass]="{ 'font-bold': rowData.type === 'Aufgabe' }"
            >
              <p-treetable-toggler [rowNode]="rowNode" />
            </td>
            <td
              style="width:3rem"
              [ngClass]="{ 'font-bold': rowData.type === 'Aufgabe' }"
            >
              {{ rowData.number }}
            </td>
            <td
              class="w-[60%]"
              [ngClass]="{ 'font-bold': rowData.type === 'Aufgabe', 'cursor-pointer': true }"
              [innerHTML]="rowData.name|shorty: 150"
              (click)="rowData.type === 'Aufgabe' ? this.toggleParentNode(rowNode) : this.openEditModal(rowData.id, 'Teilaufgabe')"
            ></td>
            <td [ngClass]="{ 'font-bold': rowData.type === 'Aufgabe' }">
              {{ rowData.points }}
            </td>
            <td [ngClass]="{ 'font-bold': rowData.type === 'Aufgabe' }">
              {{ rowData.type }}
            </td>
            <td>
              <div class="text-right">
                <i
                  class="pi pi-ellipsis-h cursor-pointer"
                  (click)="this.onContextMenu($event, rowData.type, rowData.id)"
                ></i>
                <p-contextmenu
                  #cm
                  appendTo="body"
                />
              </div>
            </td>
          </tr>
          }
          @else {
          <tr [ttRow]="rowNode">
            <td
              colspan="6"
              style="padding-left: 60px;"
            >
              <p-button
                severity="secondary"
                label="Teilaufgabe (Standard)"
                icon="pi pi-plus"
                (onClick)="this.createTeilaufgabe(rowData.id, 'standard')"
                [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
              ></p-button>
              <p-button
                class="ml-2"
                severity="secondary"
                label="Teilaufgabe (Tabelle)"
                icon="pi pi-plus"
                (onClick)="this.createTeilaufgabe(rowData.id, 'table')"
                [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
              ></p-button>
            </td>
          </tr>
          }
        </ng-template>
        <ng-template #footer>
          <tr>
            <td colspan="6">
              <p-button
                severity="secondary"
                label="Aufgabe"
                icon="pi pi-plus"
                (onClick)="this.createAufgabe()"
                [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
              ></p-button>
            </td>
          </tr>
        </ng-template>
      </p-treetable>
    </p-tabpanel>
    <p-tabpanel value="1">
      <div class="flex flex-col gap-2">
        <div>
          <span class="text-base me-2">Status:</span>
          <span class="text-base">
            @switch (this.fallaufgabenService.selectedFallaufgabe.state) {
            @case ('draft') {
            <p-tag
              severity="info"
              value="Draft"
              [rounded]="true"
            />
            }
            @case ('live') {
            <p-tag
              severity="success"
              value="Live"
              [rounded]="true"
            />
            }
            @case ('archived') {
            <p-tag
              severity="warn"
              value="Archiviert"
              [rounded]="true"
            />
            }
            }
          </span>
          @if (this.fallaufgabenService.selectedFallaufgabe.state === 'draft') {
          <p-button
            class="ms-3"
            icon="pi pi-play-circle"
            pTooltip='Fallaufgabe "Live" schalten'
            severity="success"
            size="small"
            [text]="true"
            (onClick)="this.confirmStateChange($event, 'live')"
          ></p-button>
          }
          @if (this.fallaufgabenService.selectedFallaufgabe.state === 'live') {
          <p-button
            class="ms-3"
            icon="pi pi-lock"
            pTooltip="Fallaufgabe archivieren"
            severity="warn"
            size="small"
            [text]="true"
            (onClick)="this.confirmStateChange($event, 'archived')"
          ></p-button>
          }
        </div>
        <div>
          <span class="text-base me-2">Name:</span>
          <input
            type="text"
            style="width: 234px;"
            [(ngModel)]="this.fallaufgabenService.selectedFallaufgabe.name"
            [ngModelOptions]="{ updateOn: 'blur'}"
            [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
            (ngModelChange)="this.updateFallaufgabe()"
            pInputText
            fluid
          />
        </div>
        <div>
          <span class="text-base me-2">Prüfungszeit:</span>
          <p-inputnumber
            [(ngModel)]="this.fallaufgabenService.selectedFallaufgabe.workingDurationMinutes"
            [ngModelOptions]="{ updateOn: 'change'}"
            (ngModelChange)="this.updateFallaufgabe()"
            [step]="1"
            [min]="1"
            [showButtons]="true"
            [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
            buttonLayout="horizontal"
            inputId="horizontal"
            spinnerMode="horizontal"
            mode="decimal"
            suffix=" Minuten"
          >
            <ng-template #incrementbuttonicon>
              <span class="pi pi-plus"></span>
            </ng-template>
            <ng-template #decrementbuttonicon>
              <span class="pi pi-minus"></span>
            </ng-template>
          </p-inputnumber>
        </div>
        <div>
          <span class="text-base me-2">Dokumente:</span>
          <p-multiSelect
            [options]="availableDocuments"
            optionLabel="name"
            optionValue="_id"
            [(ngModel)]="this.fallaufgabenService.selectedFallaufgabe.documentIds"
            [ngModelOptions]="{ updateOn: 'change' }"
            (ngModelChange)="this.updateFallaufgabe()"
            [filter]="true"
            [showClear]="true"
            [maxSelectedLabels]="3"
            appendTo="body"
            defaultLabel="Dokumente auswählen"
            [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
            styleClass="w-full md:w-30rem"
          />
        </div>
        <div>
          <span class="text-base me-2 ">Bearbeitungshinweise:</span>
          <app-reduced-editor
            class="mt-3"
            [saveAble]="true"
            [(model)]="this.fallaufgabenService.selectedFallaufgabe.hints"
            (onSave)="this.updateFallaufgabe()"
            [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
          ></app-reduced-editor>
        </div>
      </div>
    </p-tabpanel>
    <p-tabpanel value="2">
      <div>
        <p class="text-base mb-3">
          In dieser Fallaufgabe sind max. <b>{{ this.maxPointsInFallaufgabe }}</b> Punkte möglich.
        </p>
        <p-button
          label="Bewertungsmatrix generieren"
          severity="secondary"
          (onClick)="this.updateBewertung(); this.updateFallaufgabe();"
          [disabled]="this.fallaufgabenService.selectedFallaufgabe.state !== 'draft'"
        />
        <p-table
          class="mt-3"
          [value]="this.fallaufgabenService.selectedFallaufgabe.bewertung.schluessel"
        >
          <ng-template #header>
            <tr>
              <th class="w-1"></th>
              <th class="w-50">Punkte (min)</th>
              <th>Note</th>
            </tr>
          </ng-template>
          <ng-template
            #body
            let-noten
            let-ri="rowIndex"
          >
            <tr>
              @if (noten.note === 1) {
              <td
                [rowSpan]="this.getColSpan(true)"
                class="text-center align-middle"
              >
                <div class="flex items-center justify-center h-full w-full -rotate-90">Bestanden</div>
              </td>
              }
              @else if (noten.note === getLimitToPass()) {
              <td
                [rowSpan]="this.getColSpan(false)"
                class="text-center align-middle"
              >
                <div class="flex items-center justify-center h-full w-full -rotate-90">Nicht bestanden</div>
              </td>
              }
              <td
                [pEditableColumn]="noten.minPunkte"
                pEditableColumnField="minPunkte"
              >
                <p-cellEditor>
                  <ng-template #input>
                    <p-inputnumber
                      [inputStyle]="{ width: '60px' }"
                      [(ngModel)]="noten.minPunkte"
                      [ngModelOptions]="{ updateOn: 'blur'}"
                      (ngModelChange)="this.updateFallaufgabe()"
                      [showButtons]="true"
                      [step]="1"
                      [min]="0"
                      [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
                      buttonLayout="horizontal"
                      inputId="horizontal"
                      spinnerMode="horizontal"
                      mode="decimal"
                      size="small"
                      [minFractionDigits]="2"
                    >
                      <ng-template #incrementbuttonicon>
                        <span class="pi pi-plus"></span>
                      </ng-template>
                      <ng-template #decrementbuttonicon>
                        <span class="pi pi-minus"></span>
                      </ng-template>
                    </p-inputnumber>
                  </ng-template>
                  <ng-template #output>
                    {{ noten.minPunkte }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>{{ noten.note }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabpanel>
    <p-tabpanel value="3">
      <app-sessions />
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>


<!-- delete dialog -->
<p-confirmdialog>
  <ng-template
    pTemplate="message"
    let-message
  >
    <div>
      <span
        class="block"
        [innerHTML]="message.message"
      ></span>
      @if (this.liveStateWarning) {
      <p-message
        class="block mt-2"
        severity="warn"
        size="small"
      >
        <b>Warnung:</b> {{ this.liveStateWarning }}
      </p-message>
      }
    </div>
  </ng-template>
</p-confirmdialog>
<!-- Aufgabendialog -->
<p-dialog
  header="Aufgabe bearbeiten"
  [modal]="true"
  [(visible)]="this.isAufgabeVisible"
  [closable]="false"
  [draggable]="false"
  position="top"
  [footerTemplate]="editAufgabeFooter"
  [style]="{ width: '50rem' }"
>
  <div>
    <h3>Titel</h3>
    <input
      class="mt-3"
      type="text"
      [(ngModel)]="this.aufgabenService.selectedAufgabe.title"
      placeholder="Bitte Titel eingeben"
      [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
      pInputText
      fluid
    />
    <h3 class="mt-3">Einleitung</h3>
    <app-reduced-editor
      class="mt-3"
      [(model)]="this.aufgabenService.selectedAufgabe.einleitung"
      [disabled]="this.fallaufgabenService.selectedFallaufgabe.state === 'archived'"
    ></app-reduced-editor>
  </div>
  <ng-template #editAufgabeFooter>
    <div class="flex justify-end gap-2 mt-2">
      <p-button
        label="Abbrechen"
        severity="secondary"
        (click)="this.isAufgabeVisible = false; this.aufgabenService.reset()"
      />
      <p-button
        label="Speichern"
        severity="success"
        (click)="this.isAufgabeVisible = false; this.updateAufgabe();"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Teilaufgabendialog -->
<app-teilaufgabe-dialog
  [(visible)]="this.isTeilaufgabeVisible"
  (saved)="this.createTreeNode($event)"
/>